import React from "react";

import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

export default function FooterCard2() {
  return (<>
    <footer className="gp-footer">
      <div className="gp-footer-container">

        {/* Logo + Description */}
        <div className="gp-footer-col">
         <span className="accent-cm-fc2">Vision Classes </span>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.  
            Nunc commodo nisi nec sapien ultricies feugiat.
          </p>

         
        </div>

        {/* Company */}
        <div className="gp-footer-col">
          <h3>Company</h3>
          <a href="#">About</a>
          <a href="#">Offerings</a>
        </div>

        {/* Info */}
        <div className="gp-footer-col">
          <h3>Info</h3>
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
        </div>

        {/* Contact */}
        <div className="gp-footer-col">
          <h3>Contact</h3>
          <p>For payment or technical issues:</p>
          <p className="email">support@example.com</p>
        <div className="gp-socials">
            <FaFacebookF />
            <FaTwitter />
            <FaInstagram />
            <FaLinkedinIn />
            <FaYoutube />
          </div> </div>
          <div className="gp-footer-bottom">
        © 2025 Your Brand. All Rights Reserved.
      </div>
      </div>

      
    </footer>
    <style>{`.gp-footer {
  background: #111;margin-top:50px;
  padding: 30px 3%;padding-bottom:0px;
  color: #ddd;
  font-family: "Inter", sans-serif;
}

/* Grid layout */
.gp-footer-container {
  display: grid; padding: 30px ;  background: #222;border-radius:15px;border-bottom-left-radius:0px;border-bottom-right-radius:0px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 40px;
}

/* Logo */
.gp-logo {
  width: 180px;
  margin-bottom: 15px;
}

/* Column headings */
.gp-footer-col h3 {
//   color: #eac46f;
 color: rgba(144, 202, 249,1);
  margin-bottom: 15px;
  font-size: 1.1rem;
}
.accent-cm-fc2{ color: rgba(144, 202, 249,1);font-size:2.1rem;font-weight:bolder}
/* Links */
.gp-footer-col a {
  display: block;
  color: #bbb;
  margin-bottom: 8px;
  text-decoration: none;
  transition: 0.3s;
}
.gp-footer-col a:hover {
  color: white;
}

/* Social Icons */
.gp-socials svg {
  font-size: 20px;
  margin-right: 12px;
  cursor: pointer;
  transition: 0.3s;
}
.gp-socials svg:hover {
//   color: #eac46f;
color:rgba(144, 202, 249,1);
}

/* Contact email */
.email {
  font-weight: bold;
  color: #fff;
}

/* Footer bottom */
.gp-footer-bottom {
  text-align: center;
  margin-top: 0px;
  padding-top: 20px;
  border-top: 1px solid #222;
  font-size: 0.9rem;
  color: #888;
}
`}</style></>
  );
}
